// eslint-disable-next-line import/prefer-default-export
export const DB_NAMES = {
    GIGS: 'gigs',
    SHIFTS: 'shifts',
    CONTRACTS: 'contracts',
    AREAS: 'areas',
    ORDERS: 'orders',
    VIEWS: 'views',
    USERS: 'users',
    TICKETS: 'tickets',
}